import CashAccountSearchRequestBase from './base/CashAccountSearchRequestBase';

/**
 * @class CashAccountSearchRequest
 * @extends CashAccountSearchRequestBase
 */
class CashAccountSearchRequest extends CashAccountSearchRequestBase {

}

export default CashAccountSearchRequest;
